export default "__VITE_ASSET__CUeE49uY__"